import { useTheme } from 'styled-components';

import { CloseIcon, TransparentButton, Typography } from '@libs/components';

import { ResultFeedbackType } from 'src/constants';

import {
  CloseButtonContainer,
  CloseIconWrapper,
  Container,
  IconWrapper,
  Img,
  MainContainer,
  TextContainer,
} from './styles';

export type ToastViewProps = {
  type?: ResultFeedbackType;
  text1?: string;
  text2?: string;
  icon?: string | JSX.Element;
  className?: string;
};
type CloseButtonComponentProps = {
  closeToast: () => void;
};

export const CloseButtonComponent: React.FC<CloseButtonComponentProps> = ({
  closeToast,
}) => {
  const { colors } = useTheme();
  return (
    <CloseButtonContainer onClick={closeToast}>
      <TransparentButton>
        <CloseIconWrapper>
          <CloseIcon color={colors.text.interactive} />
        </CloseIconWrapper>
      </TransparentButton>
    </CloseButtonContainer>
  );
};
export const ToastView: React.FC<ToastViewProps> = ({
  type,
  text1,
  text2,
  icon,
}) => {
  const { colors } = useTheme();

  return (
    <Container>
      <MainContainer type={type}>
        {typeof icon === 'string' ? (
          <Img src={icon} alt="toast icon" />
        ) : (
          <IconWrapper>{icon}</IconWrapper>
        )}
        <TextContainer>
          <Typography
            type="subHeadline"
            fontFamily="primaryBold"
            color={colors.text.interactive}
          >
            {text1}
          </Typography>
          {text2 && (
            <Typography
              type="caption"
              fontFamily="primaryMedium"
              color={colors.text.interactive}
            >
              {text2}
            </Typography>
          )}
        </TextContainer>
      </MainContainer>
    </Container>
  );
};
